'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    // Set locale to moment
    _moment2.default.locale((0, _localize.getCurrentLocale)());
};

var _localize = require('linksoft/core/localize');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/moment.js
// module id = 442
// module chunks = 0